import {
  Box,
  StepLabel,
  Stepper as MuiStepper,
  Step,
  Stack,
  Typography,
} from "@mui/material";
import { UNSUCCESSFUL_STATUSES } from "Components/Merchant/InitiatePaymentDetail/PaymentProgressIndicator/constants";
import { CustomStepConnector } from "Components/Merchant/InitiatePaymentDetail/PaymentProgressIndicator/CustomStepConnector";
import { ProgressStepIcon } from "Components/Merchant/InitiatePaymentDetail/PaymentProgressIndicator/ProgressStepIcon";
import { TransactionStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  transactionStatus: TransactionStatus;
};

export const PaymentProgressIndicator = ({ transactionStatus }: Props) => {
  const { t } = useResource();

  const lastStep = UNSUCCESSFUL_STATUSES.includes(transactionStatus)
    ? transactionStatus
    : TransactionStatus.Success;

  const steps: Array<TransactionStatus> = [
    TransactionStatus.Created,
    TransactionStatus.Initiated,
    TransactionStatus.Processing,
    lastStep,
  ];

  const activeStep = transactionStatus;
  const activeIndex = steps.indexOf(activeStep);

  const stepTitle = t(
    Resources.Merchant.InitiateDetail.ProgressHeader[transactionStatus],
  );
  return (
    <Stack gap={4} width="100%">
      <Typography variant="h3" fontWeight={600}>
        {stepTitle}
      </Typography>
      <Box component="nav" aria-label="Progress" width="100%">
        <MuiStepper
          alternativeLabel
          activeStep={activeIndex}
          connector={<CustomStepConnector />}
        >
          {steps.map((step) => (
            <Step key={step}>
              <StepLabel
                slots={{
                  stepIcon: (props) => (
                    <ProgressStepIcon
                      {...props}
                      transactionStatus={transactionStatus}
                    />
                  ),
                }}
              />
            </Step>
          ))}
        </MuiStepper>
      </Box>
    </Stack>
  );
};
